"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"
import { getBlockAccentPalette } from "./accentPalette"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 64px;
  }
`

const ItemsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  row-gap: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    column-gap: 48px;
  }
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: unset;
  }
`

const StyledNumber = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$accentColor",
})<{ $accentColor?: string }>`
  margin: 0;
  color: ${({ $accentColor }) => $accentColor || sharedColors.brandDark};

  /* font-family: var(--rag); */
  height: fit-content;
  font-size: 52px !important;
  line-height: 58px !important;
  letter-spacing: 0;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 56px !important;
    line-height: 64px !important;
  }
`

type Props = {
  data: any
  blockIndex?: number
  isHomepage?: boolean
}

export default function Statistics({ data, blockIndex, isHomepage }: Props) {
  const accentColor = getBlockAccentPalette(data)?.base
  const itemsList = extractProperty(data, "itemsList") || []
  const commentLine = extractProperty(data, "commentLine")
  const items = itemsList.map((item: any) => {
    return {
      number: extractProperty(item, "number"),
      label: extractProperty(item, "label"),
    }
  }) as { number: string; label: string }[]
  const isGray = isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1
  return (
    <OuterContainer $isGray={isGray}>
      <Container paddingMobile={true}>
      <StyledContainer>
        <ItemsContainer>
          {items.map((el, i) => (
            <Item key={i}>
              <StyledNumber variant="h3" $accentColor={accentColor}>
                {el.number}
              </StyledNumber>
              <Typography variant="body1">{el.label}</Typography>
            </Item>
          ))}
        </ItemsContainer>
        <Typography variant="body3" color="#6C6C6C" textAlign={"center"}>
          {commentLine}
        </Typography>
      </StyledContainer>
      </Container>
    </OuterContainer>
  )
}
